export default class SegmentIntersector {
  processIntersections(e0, segIndex0, e1, segIndex1) {}
  isDone() {}
}
